import { Routes, Route } from 'react-router-dom';
import App from './App';
import NewsDetail from './components/NewsDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import Contact from './pages/Contact';
import CookieBanner from './components/CookieBanner';

function AppRouter() {
  return (
    <>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/noticia/:id" element={<NewsDetail />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/termos" element={<TermsOfService />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/contato" element={<Contact />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

export default AppRouter;
